export const reportFileUploadEvent = (stage: string, errorMsg: string, extraInfo?: Record<string, any>) => {
  window.Bee?.logBatchAuto({
    target_type: '',
    code: 'app-7f30cd62',
    extend: {
      stage,
      errorMsg,
      extraInfo,
    },
  });
};